/**
 * @fileoverview Input/output schemas for the character-image-prompt-creator-v2 agent.
 *
 * This agent takes character details and creates a rich, artistic prompt
 * for an image generation model.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = BaseFlowInputSchema
  .merge(AGENT_SCHEMA_OBJECTS.storySetting.schema)
  .merge(AGENT_SCHEMA_OBJECTS.characterName.schema)
  .merge(AGENT_SCHEMA_OBJECTS.existingDetailsForChapter.schema)
  .merge(AGENT_SCHEMA_OBJECTS.inspirationFullDescriptions.schema)
  .merge(AGENT_SCHEMA_OBJECTS.imageStyle.schema)
  .merge(AGENT_SCHEMA_OBJECTS.shotType.schema)
  .merge(AGENT_SCHEMA_OBJECTS.outfitDescription.schema)
  .merge(AGENT_SCHEMA_OBJECTS.userMessage.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  prompt: z.string().describe('The generated, optimized prompt for an image generation model.'),
});

export type Output = z.infer<typeof OutputSchema>;
